import { CSSProperties } from 'react';

export const PROFILE_MODAL_STYLES = {
  radioCard: {
    container: (checked: boolean, disabled: boolean = false): CSSProperties => ({
      border: checked ? '2px solid #2563eb' : '1.5px solid #E0E6ED',
      borderRadius: 12,
      background: '#fff',
      cursor: disabled ? 'not-allowed' : 'pointer',
      boxShadow: checked ? '0 0 0 2px #2563eb22' : 'none',
      display: 'flex',
      flexDirection: 'column',
      width: 224,
      minHeight: 248,
      maxHeight: 346,
      position: 'relative',
      transition: 'border 0.2s, box-shadow 0.2s',
      opacity: disabled ? 0.6 : 1,
      padding: 0,
    }),
    
    input: {
      position: 'absolute' as const,
      top: 16,
      right: 16,
      width: 20,
      height: 20,
    } as CSSProperties,
    
    header: (checked: boolean): CSSProperties => ({
      fontWeight: 700,
      fontSize: 15,
      color: '#23272f',
      padding: '16px 16px 12px 16px',
      borderBottom: '1.5px solid #E0E6ED',
      background: checked ? '#e0edff' : '#fff',
      borderTopLeftRadius: 12,
      borderTopRightRadius: 12,
      transition: 'background 0.2s',
    }),
    
    content: {
      padding: 16,
    } as CSSProperties,
  },
  
  selector: {
    container: {
      display: 'flex',
      flexDirection: 'row' as const,
    } as CSSProperties,
  }
} as const;